import { getTheme } from '@fluentui/react';
import {
  Caption1,
  makeStyles,
} from '@fluentui/react-components';
import React, { useContext } from 'react';
import { curlyTemplate } from '@bingads-webui/primitive-utilities';
import { GridContext } from '@bingads-webui-grid/grid-context';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Paginator } from '../../paginator';
import { noDataStyles } from '../../styles';

const { palette } = getTheme();
const useStyles = makeStyles({
  noData: noDataStyles(palette),
});


export const SelectCampaignsFooter = () => {
  const i18n = useContext(I18nContext);
  const styles = useStyles();
  const { state } = useContext(GridContext);

  return state.items && state.items.length > 0
    ? (
      <>
        <Caption1> {curlyTemplate(i18n.getString(_TL_('{{count}} Campaign(s)')))({ count: state.totalCount })}</Caption1>
        <Paginator />
      </>
    ) : (
      <div className={styles.noData}>
        {i18n.getString(_TL_('There are no campaigns.'))}
      </div>
    );
};
